@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_987_344_360)
internal val Res.drawable.NL7: DrawableResource by lazy {
      DrawableResource("drawable:NL7", setOf(
        ResourceItem(setOf(), "${MD}drawable/NL7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(213_733_000)
internal val Res.drawable.NL8: DrawableResource by lazy {
      DrawableResource("drawable:NL8", setOf(
        ResourceItem(setOf(), "${MD}drawable/NL8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_426_912_391)
internal val Res.drawable.NL9: DrawableResource by lazy {
      DrawableResource("drawable:NL9", setOf(
        ResourceItem(setOf(), "${MD}drawable/NL9.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_531_589_904)
internal val Res.drawable.NU1: DrawableResource by lazy {
      DrawableResource("drawable:NU1", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_075_643_430)
internal val Res.drawable.NU10: DrawableResource by lazy {
      DrawableResource("drawable:NU10", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU10.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_062_073_986)
internal val Res.drawable.NU10a: DrawableResource by lazy {
      DrawableResource("drawable:NU10a", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU10a.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_417_798_252)
internal val Res.drawable.NU11: DrawableResource by lazy {
      DrawableResource("drawable:NU11", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU11.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_808_539_135)
internal val Res.drawable.NU11a: DrawableResource by lazy {
      DrawableResource("drawable:NU11a", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU11a.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(700_989_353)
internal val Res.drawable.NU12: DrawableResource by lazy {
      DrawableResource("drawable:NU12", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU12.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_934_333_874)
internal val Res.drawable.NU13: DrawableResource by lazy {
      DrawableResource("drawable:NU13", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU13.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-187_274_689)
internal val Res.drawable.NU14: DrawableResource by lazy {
      DrawableResource("drawable:NU14", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU14.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-409_082_663)
internal val Res.drawable.NU15: DrawableResource by lazy {
      DrawableResource("drawable:NU15", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU15.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-828_418_168)
internal val Res.drawable.NU16: DrawableResource by lazy {
      DrawableResource("drawable:NU16", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU16.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_860_220_515)
internal val Res.drawable.NU17: DrawableResource by lazy {
      DrawableResource("drawable:NU17", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU17.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_502_099_729)
internal val Res.drawable.NU18: DrawableResource by lazy {
      DrawableResource("drawable:NU18", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU18.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(791_447_106)
internal val Res.drawable.NU18a: DrawableResource by lazy {
      DrawableResource("drawable:NU18a", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU18a.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(143_639_598)
internal val Res.drawable.NU19: DrawableResource by lazy {
      DrawableResource("drawable:NU19", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU19.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_278_650_473)
internal val Res.drawable.NU2: DrawableResource by lazy {
      DrawableResource("drawable:NU2", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_570_311_765)
internal val Res.drawable.NU20: DrawableResource by lazy {
      DrawableResource("drawable:NU20", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU20.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_221_384_793)
internal val Res.drawable.NU21: DrawableResource by lazy {
      DrawableResource("drawable:NU21", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU21.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_493_697_698)
internal val Res.drawable.NU22: DrawableResource by lazy {
      DrawableResource("drawable:NU22", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU22.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-827_046_887)
internal val Res.drawable.NU22a: DrawableResource by lazy {
      DrawableResource("drawable:NU22a", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU22a.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(374_263_671)
internal val Res.drawable.NU3: DrawableResource by lazy {
      DrawableResource("drawable:NU3", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-526_731_764)
internal val Res.drawable.NU4: DrawableResource by lazy {
      DrawableResource("drawable:NU4", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(543_434_433)
internal val Res.drawable.NU5: DrawableResource by lazy {
      DrawableResource("drawable:NU5", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_496_722_463)
internal val Res.drawable.NU6: DrawableResource by lazy {
      DrawableResource("drawable:NU6", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(523_489_686)
internal val Res.drawable.NU7: DrawableResource by lazy {
      DrawableResource("drawable:NU7", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(586_155_340)
internal val Res.drawable.NU8: DrawableResource by lazy {
      DrawableResource("drawable:NU8", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-558_235_173)
internal val Res.drawable.NU9: DrawableResource by lazy {
      DrawableResource("drawable:NU9", setOf(
        ResourceItem(setOf(), "${MD}drawable/NU9.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_878_552_389)
internal val Res.drawable.O1: DrawableResource by lazy {
      DrawableResource("drawable:O1", setOf(
        ResourceItem(setOf(), "${MD}drawable/O1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_061_051_525)
internal val Res.drawable.O10: DrawableResource by lazy {
      DrawableResource("drawable:O10", setOf(
        ResourceItem(setOf(), "${MD}drawable/O10.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(300_344_346)
internal val Res.drawable.O10A: DrawableResource by lazy {
      DrawableResource("drawable:O10A", setOf(
        ResourceItem(setOf(), "${MD}drawable/O10A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-25_747_424)
internal val Res.drawable.O10B: DrawableResource by lazy {
      DrawableResource("drawable:O10B", setOf(
        ResourceItem(setOf(), "${MD}drawable/O10B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-157_258_165)
internal val Res.drawable.O10C: DrawableResource by lazy {
      DrawableResource("drawable:O10C", setOf(
        ResourceItem(setOf(), "${MD}drawable/O10C.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(202_322_763)
internal val Res.drawable.O11: DrawableResource by lazy {
      DrawableResource("drawable:O11", setOf(
        ResourceItem(setOf(), "${MD}drawable/O11.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_120_242_785)
internal val Res.drawable.O12: DrawableResource by lazy {
      DrawableResource("drawable:O12", setOf(
        ResourceItem(setOf(), "${MD}drawable/O12.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_947_889_122)
internal val Res.drawable.O13: DrawableResource by lazy {
      DrawableResource("drawable:O13", setOf(
        ResourceItem(setOf(), "${MD}drawable/O13.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(930_378_945)
internal val Res.drawable.O14: DrawableResource by lazy {
      DrawableResource("drawable:O14", setOf(
        ResourceItem(setOf(), "${MD}drawable/O14.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(42_969_171)
internal val Res.drawable.O15: DrawableResource by lazy {
      DrawableResource("drawable:O15", setOf(
        ResourceItem(setOf(), "${MD}drawable/O15.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_006_443_025)
internal val Res.drawable.O16: DrawableResource by lazy {
      DrawableResource("drawable:O16", setOf(
        ResourceItem(setOf(), "${MD}drawable/O16.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_589_978_871)
internal val Res.drawable.O17: DrawableResource by lazy {
      DrawableResource("drawable:O17", setOf(
        ResourceItem(setOf(), "${MD}drawable/O17.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_241_745_039)
internal val Res.drawable.O18: DrawableResource by lazy {
      DrawableResource("drawable:O18", setOf(
        ResourceItem(setOf(), "${MD}drawable/O18.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-441_167_924)
internal val Res.drawable.O19: DrawableResource by lazy {
      DrawableResource("drawable:O19", setOf(
        ResourceItem(setOf(), "${MD}drawable/O19.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-757_647_909)
internal val Res.drawable.O19A: DrawableResource by lazy {
      DrawableResource("drawable:O19A", setOf(
        ResourceItem(setOf(), "${MD}drawable/O19A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_939_487_843)
internal val Res.drawable.O1A: DrawableResource by lazy {
      DrawableResource("drawable:O1A", setOf(
        ResourceItem(setOf(), "${MD}drawable/O1A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(193_163_562)
internal val Res.drawable.O2: DrawableResource by lazy {
      DrawableResource("drawable:O2", setOf(
        ResourceItem(setOf(), "${MD}drawable/O2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_452_307_986)
internal val Res.drawable.O20: DrawableResource by lazy {
      DrawableResource("drawable:O20", setOf(
        ResourceItem(setOf(), "${MD}drawable/O20.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_210_770_373)
internal val Res.drawable.O20A: DrawableResource by lazy {
      DrawableResource("drawable:O20A", setOf(
        ResourceItem(setOf(), "${MD}drawable/O20A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(660_769_535)
internal val Res.drawable.O21: DrawableResource by lazy {
      DrawableResource("drawable:O21", setOf(
        ResourceItem(setOf(), "${MD}drawable/O21.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(176_965_729)
internal val Res.drawable.O22: DrawableResource by lazy {
      DrawableResource("drawable:O22", setOf(
        ResourceItem(setOf(), "${MD}drawable/O22.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-102_008_192)
internal val Res.drawable.O23: DrawableResource by lazy {
      DrawableResource("drawable:O23", setOf(
        ResourceItem(setOf(), "${MD}drawable/O23.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-251_833_018)
internal val Res.drawable.O24: DrawableResource by lazy {
      DrawableResource("drawable:O24", setOf(
        ResourceItem(setOf(), "${MD}drawable/O24.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_213_617_550)
internal val Res.drawable.O24A: DrawableResource by lazy {
      DrawableResource("drawable:O24A", setOf(
        ResourceItem(setOf(), "${MD}drawable/O24A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(999_318_959)
internal val Res.drawable.O25: DrawableResource by lazy {
      DrawableResource("drawable:O25", setOf(
        ResourceItem(setOf(), "${MD}drawable/O25.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-346_268_439)
internal val Res.drawable.O25A: DrawableResource by lazy {
      DrawableResource("drawable:O25A", setOf(
        ResourceItem(setOf(), "${MD}drawable/O25A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(753_112_970)
internal val Res.drawable.O26: DrawableResource by lazy {
      DrawableResource("drawable:O26", setOf(
        ResourceItem(setOf(), "${MD}drawable/O26.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-276_155_007)
internal val Res.drawable.O27: DrawableResource by lazy {
      DrawableResource("drawable:O27", setOf(
        ResourceItem(setOf(), "${MD}drawable/O27.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(487_938_943)
internal val Res.drawable.O28: DrawableResource by lazy {
      DrawableResource("drawable:O28", setOf(
        ResourceItem(setOf(), "${MD}drawable/O28.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_146_253_932)
internal val Res.drawable.O29: DrawableResource by lazy {
      DrawableResource("drawable:O29", setOf(
        ResourceItem(setOf(), "${MD}drawable/O29.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_042_987_178)
internal val Res.drawable.O29A: DrawableResource by lazy {
      DrawableResource("drawable:O29A", setOf(
        ResourceItem(setOf(), "${MD}drawable/O29A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_851_277_409)
internal val Res.drawable.O3: DrawableResource by lazy {
      DrawableResource("drawable:O3", setOf(
        ResourceItem(setOf(), "${MD}drawable/O3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-522_164_633)
internal val Res.drawable.O30: DrawableResource by lazy {
      DrawableResource("drawable:O30", setOf(
        ResourceItem(setOf(), "${MD}drawable/O30.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-29_807_443)
internal val Res.drawable.O30A: DrawableResource by lazy {
      DrawableResource("drawable:O30A", setOf(
        ResourceItem(setOf(), "${MD}drawable/O30A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-739_000_130)
internal val Res.drawable.O31: DrawableResource by lazy {
      DrawableResource("drawable:O31", setOf(
        ResourceItem(setOf(), "${MD}drawable/O31.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_104_062_206)
internal val Res.drawable.O32: DrawableResource by lazy {
      DrawableResource("drawable:O32", setOf(
        ResourceItem(setOf(), "${MD}drawable/O32.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_091_901_224)
internal val Res.drawable.O33: DrawableResource by lazy {
      DrawableResource("drawable:O33", setOf(
        ResourceItem(setOf(), "${MD}drawable/O33.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_584_811_405)
internal val Res.drawable.O33A: DrawableResource by lazy {
      DrawableResource("drawable:O33A", setOf(
        ResourceItem(setOf(), "${MD}drawable/O33A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(738_700_146)
internal val Res.drawable.O34: DrawableResource by lazy {
      DrawableResource("drawable:O34", setOf(
        ResourceItem(setOf(), "${MD}drawable/O34.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_006_038_523)
internal val Res.drawable.O35: DrawableResource by lazy {
      DrawableResource("drawable:O35", setOf(
        ResourceItem(setOf(), "${MD}drawable/O35.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_450_749_804)
internal val Res.drawable.O36: DrawableResource by lazy {
      DrawableResource("drawable:O36", setOf(
        ResourceItem(setOf(), "${MD}drawable/O36.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(157_063_312)
internal val Res.drawable.O36A: DrawableResource by lazy {
      DrawableResource("drawable:O36A", setOf(
        ResourceItem(setOf(), "${MD}drawable/O36A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(228_637_018)
internal val Res.drawable.O36B: DrawableResource by lazy {
      DrawableResource("drawable:O36B", setOf(
        ResourceItem(setOf(), "${MD}drawable/O36B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_717_130_629)
internal val Res.drawable.O36C: DrawableResource by lazy {
      DrawableResource("drawable:O36C", setOf(
        ResourceItem(setOf(), "${MD}drawable/O36C.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_682_568_769)
internal val Res.drawable.O36D: DrawableResource by lazy {
      DrawableResource("drawable:O36D", setOf(
        ResourceItem(setOf(), "${MD}drawable/O36D.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_822_635_845)
internal val Res.drawable.O37: DrawableResource by lazy {
      DrawableResource("drawable:O37", setOf(
        ResourceItem(setOf(), "${MD}drawable/O37.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_964_066_708)
internal val Res.drawable.O38: DrawableResource by lazy {
      DrawableResource("drawable:O38", setOf(
        ResourceItem(setOf(), "${MD}drawable/O38.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(435_961_827)
internal val Res.drawable.O39: DrawableResource by lazy {
      DrawableResource("drawable:O39", setOf(
        ResourceItem(setOf(), "${MD}drawable/O39.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_127_724_632)
internal val Res.drawable.O4: DrawableResource by lazy {
      DrawableResource("drawable:O4", setOf(
        ResourceItem(setOf(), "${MD}drawable/O4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-894_144_703)
internal val Res.drawable.O40: DrawableResource by lazy {
      DrawableResource("drawable:O40", setOf(
        ResourceItem(setOf(), "${MD}drawable/O40.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_299_608_743)
internal val Res.drawable.O41: DrawableResource by lazy {
      DrawableResource("drawable:O41", setOf(
        ResourceItem(setOf(), "${MD}drawable/O41.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_808_722_220)
internal val Res.drawable.O42: DrawableResource by lazy {
      DrawableResource("drawable:O42", setOf(
        ResourceItem(setOf(), "${MD}drawable/O42.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_814_647_627)
internal val Res.drawable.O43: DrawableResource by lazy {
      DrawableResource("drawable:O43", setOf(
        ResourceItem(setOf(), "${MD}drawable/O43.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_463_550_732)
internal val Res.drawable.O44: DrawableResource by lazy {
      DrawableResource("drawable:O44", setOf(
        ResourceItem(setOf(), "${MD}drawable/O44.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_297_213_990)
internal val Res.drawable.O45: DrawableResource by lazy {
      DrawableResource("drawable:O45", setOf(
        ResourceItem(setOf(), "${MD}drawable/O45.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_941_755_692)
internal val Res.drawable.O46: DrawableResource by lazy {
      DrawableResource("drawable:O46", setOf(
        ResourceItem(setOf(), "${MD}drawable/O46.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_198_030_340)
internal val Res.drawable.O47: DrawableResource by lazy {
      DrawableResource("drawable:O47", setOf(
        ResourceItem(setOf(), "${MD}drawable/O47.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_090_523_601)
internal val Res.drawable.O48: DrawableResource by lazy {
      DrawableResource("drawable:O48", setOf(
        ResourceItem(setOf(), "${MD}drawable/O48.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_748_050_880)
internal val Res.drawable.O49: DrawableResource by lazy {
      DrawableResource("drawable:O49", setOf(
        ResourceItem(setOf(), "${MD}drawable/O49.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_396_398_493)
internal val Res.drawable.O5: DrawableResource by lazy {
      DrawableResource("drawable:O5", setOf(
        ResourceItem(setOf(), "${MD}drawable/O5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_831_307_480)
internal val Res.drawable.O50: DrawableResource by lazy {
      DrawableResource("drawable:O50", setOf(
        ResourceItem(setOf(), "${MD}drawable/O50.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_968_479_219)
internal val Res.drawable.O50A: DrawableResource by lazy {
      DrawableResource("drawable:O50A", setOf(
        ResourceItem(setOf(), "${MD}drawable/O50A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_076_771_766)
internal val Res.drawable.O50B: DrawableResource by lazy {
      DrawableResource("drawable:O50B", setOf(
        ResourceItem(setOf(), "${MD}drawable/O50B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(890_588_217)
internal val Res.drawable.O51: DrawableResource by lazy {
      DrawableResource("drawable:O51", setOf(
        ResourceItem(setOf(), "${MD}drawable/O51.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-609_843_737)
internal val Res.drawable.O5A: DrawableResource by lazy {
      DrawableResource("drawable:O5A", setOf(
        ResourceItem(setOf(), "${MD}drawable/O5A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_065_674_654)
internal val Res.drawable.O6: DrawableResource by lazy {
      DrawableResource("drawable:O6", setOf(
        ResourceItem(setOf(), "${MD}drawable/O6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_468_472_141)
internal val Res.drawable.O6A: DrawableResource by lazy {
      DrawableResource("drawable:O6A", setOf(
        ResourceItem(setOf(), "${MD}drawable/O6A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_748_749_611)
internal val Res.drawable.O6B: DrawableResource by lazy {
      DrawableResource("drawable:O6B", setOf(
        ResourceItem(setOf(), "${MD}drawable/O6B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(547_645_326)
internal val Res.drawable.O6C: DrawableResource by lazy {
      DrawableResource("drawable:O6C", setOf(
        ResourceItem(setOf(), "${MD}drawable/O6C.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-782_448_750)
internal val Res.drawable.O6D: DrawableResource by lazy {
      DrawableResource("drawable:O6D", setOf(
        ResourceItem(setOf(), "${MD}drawable/O6D.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(566_467_951)
internal val Res.drawable.O6E: DrawableResource by lazy {
      DrawableResource("drawable:O6E", setOf(
        ResourceItem(setOf(), "${MD}drawable/O6E.webp", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable6Resources(map: MutableMap<String, DrawableResource>) {
  map.put("NL7", Res.drawable.NL7)
  map.put("NL8", Res.drawable.NL8)
  map.put("NL9", Res.drawable.NL9)
  map.put("NU1", Res.drawable.NU1)
  map.put("NU10", Res.drawable.NU10)
  map.put("NU10a", Res.drawable.NU10a)
  map.put("NU11", Res.drawable.NU11)
  map.put("NU11a", Res.drawable.NU11a)
  map.put("NU12", Res.drawable.NU12)
  map.put("NU13", Res.drawable.NU13)
  map.put("NU14", Res.drawable.NU14)
  map.put("NU15", Res.drawable.NU15)
  map.put("NU16", Res.drawable.NU16)
  map.put("NU17", Res.drawable.NU17)
  map.put("NU18", Res.drawable.NU18)
  map.put("NU18a", Res.drawable.NU18a)
  map.put("NU19", Res.drawable.NU19)
  map.put("NU2", Res.drawable.NU2)
  map.put("NU20", Res.drawable.NU20)
  map.put("NU21", Res.drawable.NU21)
  map.put("NU22", Res.drawable.NU22)
  map.put("NU22a", Res.drawable.NU22a)
  map.put("NU3", Res.drawable.NU3)
  map.put("NU4", Res.drawable.NU4)
  map.put("NU5", Res.drawable.NU5)
  map.put("NU6", Res.drawable.NU6)
  map.put("NU7", Res.drawable.NU7)
  map.put("NU8", Res.drawable.NU8)
  map.put("NU9", Res.drawable.NU9)
  map.put("O1", Res.drawable.O1)
  map.put("O10", Res.drawable.O10)
  map.put("O10A", Res.drawable.O10A)
  map.put("O10B", Res.drawable.O10B)
  map.put("O10C", Res.drawable.O10C)
  map.put("O11", Res.drawable.O11)
  map.put("O12", Res.drawable.O12)
  map.put("O13", Res.drawable.O13)
  map.put("O14", Res.drawable.O14)
  map.put("O15", Res.drawable.O15)
  map.put("O16", Res.drawable.O16)
  map.put("O17", Res.drawable.O17)
  map.put("O18", Res.drawable.O18)
  map.put("O19", Res.drawable.O19)
  map.put("O19A", Res.drawable.O19A)
  map.put("O1A", Res.drawable.O1A)
  map.put("O2", Res.drawable.O2)
  map.put("O20", Res.drawable.O20)
  map.put("O20A", Res.drawable.O20A)
  map.put("O21", Res.drawable.O21)
  map.put("O22", Res.drawable.O22)
  map.put("O23", Res.drawable.O23)
  map.put("O24", Res.drawable.O24)
  map.put("O24A", Res.drawable.O24A)
  map.put("O25", Res.drawable.O25)
  map.put("O25A", Res.drawable.O25A)
  map.put("O26", Res.drawable.O26)
  map.put("O27", Res.drawable.O27)
  map.put("O28", Res.drawable.O28)
  map.put("O29", Res.drawable.O29)
  map.put("O29A", Res.drawable.O29A)
  map.put("O3", Res.drawable.O3)
  map.put("O30", Res.drawable.O30)
  map.put("O30A", Res.drawable.O30A)
  map.put("O31", Res.drawable.O31)
  map.put("O32", Res.drawable.O32)
  map.put("O33", Res.drawable.O33)
  map.put("O33A", Res.drawable.O33A)
  map.put("O34", Res.drawable.O34)
  map.put("O35", Res.drawable.O35)
  map.put("O36", Res.drawable.O36)
  map.put("O36A", Res.drawable.O36A)
  map.put("O36B", Res.drawable.O36B)
  map.put("O36C", Res.drawable.O36C)
  map.put("O36D", Res.drawable.O36D)
  map.put("O37", Res.drawable.O37)
  map.put("O38", Res.drawable.O38)
  map.put("O39", Res.drawable.O39)
  map.put("O4", Res.drawable.O4)
  map.put("O40", Res.drawable.O40)
  map.put("O41", Res.drawable.O41)
  map.put("O42", Res.drawable.O42)
  map.put("O43", Res.drawable.O43)
  map.put("O44", Res.drawable.O44)
  map.put("O45", Res.drawable.O45)
  map.put("O46", Res.drawable.O46)
  map.put("O47", Res.drawable.O47)
  map.put("O48", Res.drawable.O48)
  map.put("O49", Res.drawable.O49)
  map.put("O5", Res.drawable.O5)
  map.put("O50", Res.drawable.O50)
  map.put("O50A", Res.drawable.O50A)
  map.put("O50B", Res.drawable.O50B)
  map.put("O51", Res.drawable.O51)
  map.put("O5A", Res.drawable.O5A)
  map.put("O6", Res.drawable.O6)
  map.put("O6A", Res.drawable.O6A)
  map.put("O6B", Res.drawable.O6B)
  map.put("O6C", Res.drawable.O6C)
  map.put("O6D", Res.drawable.O6D)
  map.put("O6E", Res.drawable.O6E)
}
